import './css/styles.scss';

function InitBlock() {}

function BoxInfoBlock() {

    const butiksListan = document.querySelector('.lista-vara-butiker-item ');
	if (!butiksListan) return;


	const butiker = butiksListan.querySelectorAll('.accordion-item');
	if (!butiker.length) return;
        if (window.innerWidth >= 768) { // code for large screens
        butiker.forEach((element) => {
            element.addEventListener("click", function (e) {
                e.preventDefault();
                // Remove 'active' tag for all list items 
                for (let i = 0; i < butiker.length; i++) { 
                    butiker[i].classList.remove("active");
                    butiker[i].classList.add("hide"); 
                }
                const info = document.querySelectorAll('.accorion-content');
                // Remove 'active' tag for all info items
                for (let i = 0; i < info.length; i++) { 
                    info[i].classList.remove("active");
                    info[i].classList.add("hide");
                }
                e.target.classList.add('active');
                const itemIndex = e.target.getAttribute('data-index'); 
                const content = document.querySelector(`.accorion-content[data-index="${itemIndex}"]`)
                content.classList.add('active');
                /*if (content.style.display === "none") {
                    content.style.display = "block";
                } else {
                    content.style.display = "none";
                }*/
            }, false);
        });
    }
    if (window.innerWidth < 768) { // code for large screens
        const butikerMob = butiksListan.querySelectorAll('.accordion-item');
        if (!butiker.length) return;

        butikerMob.forEach((element) => {
            element.addEventListener("click", function (e) {
                e.preventDefault();
                // Remove 'active' tag for all list items 
                for (let i = 0; i < butikerMob.length; i++) { 
                    butikerMob[i].classList.remove("active");
                    butikerMob[i].classList.add("hide"); 
                }
                const info = document.querySelectorAll('.accorion-content-mob');
                // Remove 'active' tag for all info items
                for (let i = 0; i < info.length; i++) { 
                    info[i].classList.remove("active");
                    info[i].classList.add("hide");
                }
                e.target.classList.add('active');
                const itemIndex = e.target.getAttribute('data-index'); 
                const content = document.querySelector(`.accorion-content-mob[data-index="${itemIndex}"]`)
                content.classList.add('active');
                /*if (content.style.display === "none") {
                    content.style.display = "block";
                } else {
                    content.style.display = "none";
                }*/
            }, false);
        });
    }
}


InitBlock();
BoxInfoBlock();

// on dom ready
// Make sure to call the function -.-'
document.addEventListener('DOMContentLoaded', () => {
	BoxInfoBlock();
});
